var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useMemo } from 'react';
import { FoldableListChat } from '@/components/modules/Chat/FoldableListChat';
import { RfpProfessionalNegotiateStatusTag } from '@/components/modules/pages/rfp/professional/Tag/RfpProfessionalNegotiateStatusTag';
import { Text } from '@/components/ui/Typography/Body/Text';
import { isNonNumericFalsyValue } from '@/utils/checkValue/number';
import { RFP_NEGOTIATE_MESSAGE_STATUS_PUBLIC, RFP_NEGOTIATE_MESSAGE_STATUS_DRAFT, } from '@/utils/constants/rfp/rfpNegotiate/rfpNegotiateMessage/status';
import { RFP_NEGOTIATE_STATUS_DEFAULT } from '@/utils/constants/rfp/rfpNegotiate/status';
import { rfpNegotiateMessageValidation } from '@/utils/validate/resources/rfp/rfpNegotiateMessage';
/**
 * コンサルタント：案件詳細（条件相談）を表示するコンポーネント
 * @constructor
 */
export const RfpProfessionalNegotiateListItem = (props) => {
    const { className = '', displayLastMessage, isShowForm = true, negotiate, onClickSubmit: propOnClickSubmit, titleText, titleValue, type, user, } = props;
    const { messages, status } = negotiate;
    const draftMessage = useMemo(() => {
        var _a, _b;
        return negotiate.draft_message
            ? {
                id: (_a = negotiate.draft_message) === null || _a === void 0 ? void 0 : _a.id,
                message: (_b = negotiate.draft_message) === null || _b === void 0 ? void 0 : _b.description,
            }
            : null;
    }, [negotiate.draft_message]);
    /** TODO: クライアント側と共通の整形するuseっぽいものが欲しい */
    const items = useMemo(() => messages.map((message) => ({
        message: {
            isBox: !message.is_same_organization,
            message: message.description,
            messageId: message.id,
            time: message.published_at,
            unread: message.is_unread,
        },
        user: {
            clientId: isNonNumericFalsyValue(message.client_id)
                ? ''
                : `${message.client_id}`,
            firstName: message.first_name,
            imageSrc: message.image_src,
            isRetired: message.is_retired,
            isShowDetailPage: false,
            lastName: message.last_name || 'クライアント企業担当者より',
            professionalId: isNonNumericFalsyValue(message.professional_id)
                ? ''
                : `${message.professional_id}`,
            professionalType: message.professional_type,
        },
    })), [messages]);
    /** 送信 */
    const onClickSubmit = useCallback((args, form) => __awaiter(void 0, void 0, void 0, function* () {
        yield propOnClickSubmit({
            description: args.description,
            status: RFP_NEGOTIATE_MESSAGE_STATUS_PUBLIC.value,
            type,
        }, form);
    }), [propOnClickSubmit, type]);
    /** 下書き保存 */
    const onClickDraft = useCallback((args, form) => __awaiter(void 0, void 0, void 0, function* () {
        yield propOnClickSubmit({
            description: args.description,
            status: RFP_NEGOTIATE_MESSAGE_STATUS_DRAFT.value,
            type,
        }, form);
    }), [propOnClickSubmit, type]);
    return (_jsxs("div", Object.assign({ className: clsx('w-full', 'flex flex-col sm:flex-col md:flex-row', 'gap-y-16 gap-x-28 sm:gap-x-12', className) }, { children: [_jsxs("div", Object.assign({ className: clsx('w-full md:w-[210px]', 'flex flex-col flex-shrink-0', 'overflow-hidden', 'gap-4') }, { children: [_jsxs("div", Object.assign({ className: clsx('mt-0 md:mt-8') }, { children: [_jsxs(Text, Object.assign({ className: clsx('inline-flex', 'whitespace-nowrap'), color: 'base', isBold: true, size: 'md' }, { children: [titleText, "\uFF1A"] })), _jsx(Text, Object.assign({ className: clsx('inline-flex', 'whitespace-nowrap'), color: 'base', size: 'md' }, { children: titleValue }))] })), status !== RFP_NEGOTIATE_STATUS_DEFAULT.value && (_jsx("div", { children: _jsx(RfpProfessionalNegotiateStatusTag, { status: status }) }))] })), _jsx("div", Object.assign({ className: clsx('grow-[2]') }, { children: !isShowForm && !items.length ? (_jsx(Text, Object.assign({ className: clsx('mt-0 md:mt-8'), color: 'base', size: 'sm' }, { children: "\u76F8\u8AC7\u5185\u5BB9\u306F\u3042\u308A\u307E\u305B\u3093" }))) : (_jsx(FoldableListChat, { displayLastMessage: displayLastMessage, draftMessage: draftMessage, isShowForm: isShowForm, items: items, onClickDraft: onClickDraft, onClickSubmit: onClickSubmit, user: user, validateOfMessage: rfpNegotiateMessageValidation.description })) }))] })));
};
